var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"typing-text"},[(!_vm.interval)?_c('span',{style:(_vm.style),domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e(),_c('span',{style:(_vm.style),domProps:{"textContent":_vm._s(_vm.current)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }